<template>
  <div role="main" class="container pb-3 pt-0">
    <!-- Título + botón calendario -->
    <div class="d-flex mb-3 justify-content-between">
      <h2 class="font-weight-bold mb-0">
        <a
          class="button"
          @click="regresar()"
          style="display: flex; align-items: center; cursor: pointer"
          ><i class="fas fa-angle-left button mr-1"></i
          ><span style="font-size: 14px">Regresar</span></a
        >
      </h2>
      <div class="text-right mb-2">
        <span class="badge" :class="estadoBadgeClase">{{
          estadoBadgeTexto
        }}</span>
      </div>
    </div>
    <h2 class="titulo-cap font-weight-bold">Detalle del curso</h2>
    <div v-if="loading" class="text-center p-4">
      <div class="spinner-border" role="status"></div>
      <div class="mt-2">Cargando detalles…</div>
    </div>
    <div v-else>
      <div
        class="evento-card"
        :class="{
          'evento-finalizado': estadoCurso === 'finalizado',
          'evento-confirmado': estadoCurso === 'confirmado',
        }"
        style="transform: none; cursor: auto"
      >
        <div class="badge-top">
          <div class="icons-col">
            <i class="fas fa-graduation-cap"></i>
          </div>
          <h6 class="title mb-0 text-left">{{ evento.curso?.nombre }}</h6>
        </div>

        <hr class="sep" />

        <!-- CONTENIDO -->
        <div class="inner">
          <div v-if="evento.cot" class="d-flex align-items-center mb-2">
            <i class="far fa-building mr-2"></i>
            <span class="title mb-0">{{ evento.cot?.name }}</span>
          </div>
          <div v-else class="d-flex align-items-center mb-2">
            <span class="title mb-0">{{ evento.title }}</span>
          </div>

          <div class="d-flex align-items-center mb-2">
            <i class="far fa-calendar mr-2"></i>
            <span class="text-req">{{ formatearFecha(evento.start) }}</span>
          </div>
          <div class="d-flex align-items-center mb-2">
            <i class="far fa-clock mr-2"></i>
            <span class="text-req">{{
              formatearRangoHoras(evento.start, evento.end)
            }}</span>
          </div>
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-clipboard-check mr-2"></i>
            <span class="badge" :class="estadoBadgeClase">{{
              estadoBadgeTexto
            }}</span>
            <small
              v-if="evento.fecha_confirmacion_capacitador"
              class="text-muted ml-2"
            >
              {{ formatearFechaHora(evento.fecha_confirmacion_capacitador) }}
            </small>
          </div>
          <div class="d-flex align-items-center mb-2">
            <i class="far fa-credit-card mr-2"></i>
            <span class="text-req text-left"
              ><b>Viáticos: </b>{{ evento.viaticos }}</span
            >
          </div>
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-fire-extinguisher mr-2"></i>
            <span class="text-req text-left"
              ><b>Práctica: </b
              >{{ evento.practica ? evento.practica : "Sin práctica" }}</span
            >
          </div>
          <div v-if="evento.contacto" class="d-flex align-items-center mb-2">
            <i class="fas fa-user mr-2"></i>
            <span class="text-req text-left"
              ><b>Contacto: </b>{{ evento.contacto }}</span
            >
          </div>
          <div v-if="evento.lugar" class="d-flex align-items-center mb-2">
            <i class="fas fa-map-pin mr-3"></i>
            <span class="text-req text-left"
              ><b>Lugar: </b>{{ evento.lugar }}</span
            >
          </div>

          <div v-if="evento.observaciones" class="d-flex align-items-center">
            <i class="fas fa-info mr-3"></i>
            <span class="text-req text-left"
              ><b>Observaciones: </b>{{ evento.observaciones }}</span
            >
          </div>
          <div class="d-flex justify-content-start">
            <a
              v-if="evento.linkUbicacion"
              :href="evento.linkUbicacion"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-primary btn-sm mr-2 mt-2"
            >
              Mostrar ubicación
            </a>

            <a
              class="btn btn-outline-dark btn-sm mr-2 mt-2"
              href="/formatosCap/CEDULA_SIMULACRO.pdf"
              download
            >
              <i class="fas fa-file-download mr-1"></i>Cédula Simulacro
            </a>
            <a
              class="btn btn-outline-dark btn-sm mt-2"
              href="/formatosCap/LISTA_ASISTENCIA.pdf"
              download
            >
              <i class="fas fa-file-download mr-1"></i>Lista Asistencia
            </a>
          </div>
          <button
            v-if="estadoCurso === 'por_confirmar'"
            class="btn btn-outline-primary mt-3 btn-sm"
            style="width: 100%"
            :disabled="loadingConfirmar"
            @click="confirmarCurso()"
          >
            <span
              v-if="loadingConfirmar"
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
            ></span>
            Confirmar curso
          </button>
          <button
            class="btn btn-animated mt-3 btn-sm"
            :class="estadoCurso === 'finalizado' ? 'btn-secondary' : 'btn-finalizar'"
            style="width: 100%"
            :disabled="estadoCurso === 'por_confirmar'"
            @click="finalizarCurso()"
          >
            <span
              v-if="loadingFinalizar"
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
            ></span>
            {{
              estadoCurso === "finalizado" ? "Marcar como no finalizado" : "Finalizar curso"
            }}
          </button>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-6 col-lg-6 mb-4"
          v-for="(doc, index1) in evento?.documentos"
          :key="index1"
          style="margin-bottom: 0.5rem !important"
        >
          <div
            class="card-document"
            :class="{
              pendiente: doc.archivos.length === 0,
              aceptado: doc.archivos.length > 0,
            }"
          >
            <div class="card-document-body">
              <div style="text-align: left; max-width: 60%">
                <div class="d-flex align-items-center">
                  <h6
                    class="m-0"
                    style="overflow-wrap: break-word; max-width: 100%"
                  >
                    {{ doc.detalles.nombre }}
                  </h6>
                </div>
                <span class="card-text"
                  ><b>Archivos subidos: </b>{{ doc.archivos.length }}</span
                >
              </div>
              <div>
                <button
                  class="btn-doc btn-primary"
                  @click="abrirModal(doc, index1)"
                >
                  {{
                    doc.archivos.length > 0
                      ? "Actualizar archivo"
                      : "Subir archivos"
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <form
        v-if="evento.curso && (evento.curso.id === 4 || evento.curso.id === 6)"
        @submit.prevent="submitForm"
        class="form-cedula"
      >
        <!-- Sección: Cédula del simulacro -->
        <h5 class="encabezado-form mt-4">Cédula del simulacro</h5>
        <div class="row">
          <div class="col-md-6 form-group">
            <label>Hora de inicio</label>
            <input
              type="time"
              class="form-control"
              v-model="cedula.inicio"
              required
            />
          </div>
          <div class="col-md-6 form-group">
            <label>Hora de termino</label>
            <input
              type="time"
              class="form-control"
              v-model="cedula.fin"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 form-group">
            <label>Duración total del ejercicio</label>
            <input
              type="text"
              class="form-control"
              maxlength="30"
              v-model="cedula.duracion_ejercicio"
              required
            />
          </div>
          <div class="col-md-4 form-group">
            <label>Tiempo de evacuación del inmueble (MM:SS)</label>
            <input
              type="text"
              class="form-control"
              :value="cedula.duracion_simulacro"
              @accept="onMaskAccept"
              v-imask="maskOptions"
              required
              inputmode="numeric"
            />
          </div>
          <div class="col-md-4 form-group">
            <label>Personas evacuadas</label>
            <input
              type="number"
              class="form-control"
              v-model="cedula.personas_evacuadas"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
            <label>Observaciones</label>
            <textarea
              type="text"
              class="form-control"
              maxlength="199"
              v-model="cedula.observaciones"
              required
            ></textarea>
          </div>
        </div>
        <button
          type="submit"
          class="btn m-3"
          :class="loadingFormCedula ? 'btn-secondary disabled' : 'btn-primary'"
        >
          <span
            v-if="loadingFormCedula"
            class="spinner-border spinner-border-sm mr-2"
            role="status"
            aria-hidden="true"
          ></span>
          {{ loadingFormCedula ? "Guardando..." : "Guardar" }}
        </button>
      </form>
    </div>
    <ModalFile
      v-if="mostrarModal"
      :visible="mostrarModal"
      :documento-id="doc.id"
      :nombre_doc="doc.detalles.nombre"
      :servicio-id="null"
      :archivos_pre="doc.archivos"
      :index="indexActual"
      :maxFiles="100"
      @close-modal="cerrarModal"
      @archivo-subido="archivoSubido"
      @archivo-eliminado="actualizarListaDeArchivos"
    />

    <FlashMessage
      :style="{ position: 'fixed', zIndex: 9999, fontSize: '18px' }"
    />
  </div>
</template>

<script>
import axiosInstance from "../../services/axiosInstance";
import ModalFile from "../Capacitador/ModalFileCapacitador.vue";
import { IMaskDirective } from "vue-imask";
//import EventoCard from '@/components/EventoCard.vue'

export default {
  name: "HomeCapacitador",
  directives: {
    imask: IMaskDirective,
  },
  components: {
    ModalFile,
  },
  data() {
    return {
      evento: [],
      cedula: {
        inicio: "",
        fin: "",
        duracion_ejercicio: "",
        personas_evacuadas: "",
        duracion_simulacro: null,
        observaciones: "",
      },
      mostrarModal: null,
      doc: null,
      indexActual: null,
      loading: false,
      loadingFormCedula: false,
      loadingConfirmar: false,
      loadingFinalizar: false,
      maskOptions: {
        mask: "00:00",
        lazy: false,
        placeholderChar: "0",
      },
    };
  },
  watch: {
    doc() {},
  },
  computed: {
    estadoCurso() {
      if (Number(this.evento?.edo) === 1) return "finalizado";
      return this.evento?.estado_capacitador || "por_confirmar";
    },
    estadoBadgeTexto() {
      return {
        por_confirmar: "Por confirmar",
        confirmado: "Confirmado",
        finalizado: "Finalizado",
        historico: "Histórico",
      }[this.estadoCurso] || "Por confirmar";
    },
    estadoBadgeClase() {
      return {
        por_confirmar: "badge-warning",
        confirmado: "badge-primary",
        finalizado: "badge-success",
        historico: "badge-secondary",
      }[this.estadoCurso] || "badge-warning";
    },
  },
  methods: {
    onMaskAccept(e) {
      this.cedula.duracion_simulacro = e.detail.value;
    },
    async obtenerEvento() {
      const ev = this.$route.query.ev ? JSON.parse(this.$route.query.ev) : null;

      this.loading = true;
      try {
        const response = await axiosInstance.get("/cap/detalles", {
          params: {
            id: ev,
          },
        });
        this.evento = response.data;
        if (this.evento.cedula) {
          if (this.evento.cedula.duracion_simulacro == "00:00") {
            this.evento.cedula.duracion_simulacro = "";
          }
          this.cedula = this.evento.cedula;
        }
      } catch (error) {
        console.error("Error al obtener datos de los eventos:", error);
      } finally {
        this.loading = false;
      }
    },
    formatearRangoHoras(inicio, fin) {
      const formatoHora = (fecha) => {
        const hora = new Date(fecha).getUTCHours().toString().padStart(2, "0");
        const minuto = new Date(fecha)
          .getUTCMinutes()
          .toString()
          .padStart(2, "0");
        return `${hora}:${minuto}`;
      };

      return `${formatoHora(inicio)} a ${formatoHora(fin)} hrs.`;
    },
    formatearFecha(fecha) {
      if (!fecha) return "";
      return new Date(fecha).toLocaleString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    formatearFechaHora(fecha) {
      if (!fecha) return "";
      return new Date(fecha).toLocaleString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    abrirModal(doc, index) {
      this.mostrarModal = true;
      this.doc = doc;
      this.indexActual = index;
    },
    cerrarModal() {
      this.mostrarModal = false;
    },
    async archivoSubido({ archivos }) {
      this.doc.archivos.push(archivos);
    },
    actualizarListaDeArchivos(payload) {
      if (payload && payload.all) {
        this.doc.archivos = [];
      } else {
        const id = payload;
        this.doc.archivos = this.doc.archivos.filter((a) => a.id !== id);
      }
    },
    async submitForm() {
      const formData = new FormData(); // Crear un nuevo objeto FormData

      formData.append("formData", JSON.stringify(this.cedula));
      formData.append("id", this.evento.id);
      this.loadingFormCedula = true;
      try {
        await axiosInstance.post("/cap/updateCedulaSimulacro", formData);
        this.flashMessage.success({
          message: "[ÉXITO]: Datos de la cedula guardados con éxito",
          time: 2000,
        });
      } catch (error) {
        this.flashMessage.error({
          message: "[ERROR]: Hubo un problema al actualizar",
        });
      } finally {
        this.loadingFormCedula = false;
      }
    },
    regresar() {
      this.$router.go(-1);
    },
    async confirmarCurso() {
      this.loadingConfirmar = true;
      try {
        const { data } = await axiosInstance.post("/cap/confirmarEvento", {
          id: this.evento.id,
        });

        this.evento = data;

        this.flashMessage.success({
          message: "[ÉXITO]: Curso confirmado",
          time: 2000,
        });
      } catch (error) {
        this.flashMessage.warning({
          message:
            error.response?.data?.message ||
            "No se pudo confirmar el curso, intentalo mas tarde",
          time: 3500,
        });
      } finally {
        this.loadingConfirmar = false;
      }
    },
    async finalizarCurso() {
      if (this.estadoCurso === "por_confirmar") {
        this.flashMessage.warning({
          message: "Confirma el curso antes de finalizarlo",
          time: 2000,
        });
        return;
      }

      this.loadingFinalizar = true;
      try {
        const { data } = await axiosInstance.post("/cap/finalizarEvento", {
          id: this.evento.id,
        });

        // Espera un 0/1 y lo asigna; si viene otra cosa, lo trata como 0
        const edo = Number(data) === 1 ? 1 : 0;
        this.$set(this.evento, "edo", edo);
        this.$set(
          this.evento,
          "estado_capacitador",
          edo === 1 ? "finalizado" : "confirmado"
        );

        this.flashMessage.success({
          message: "[ÉXITO]: Curso actualizado",
          time: 2000,
        });
      } catch (_) {
        // Cualquier cosa que realmente lance, avisa simple
        this.flashMessage.warning({
          message: "El sistema no está disponible, intentalo mas tarde",
          time: 2000,
        });
      } finally {
        this.loadingFinalizar = false;
      }
    },
  },
  mounted() {
    this.obtenerEvento();
  },
};
</script>

<style>
/* Cinta superior */
.badge-top {
  color: #6c757d;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 10px 16px;
  display: flex;
  align-items: center;
}

.evento-finalizado {
  border-left: 6px solid #28a745;
}

.evento-confirmado {
  border-left: 6px solid #2563eb;
}

/* Separador */
.sep {
  border: 0;
  border-top: 1px solid #e9edf5;
  margin: 8px 0 10px;
}

/* Interior */
.inner {
  padding: 14px 16px 16px 16px;
}
.icons-col {
  color: #0f3e82;
  margin-right: 8px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
}

.form-cedula {
  border: 1px solid #f4f6fb;
  border-radius: 7px;
  padding: 10px;
  box-shadow: 0 2px 10px rgba(17, 38, 146, 0.08);
}

.btn-finalizar {
  background-color: #0f3f82e8 !important;
  color: #fff !important; /* opcional para contraste */
}

@media (max-width: 768px) {
  .titulo-cap {
    font-size: 1.6rem;
  }
}
</style>
